// src/views/esataciones/PinesMaestros/ListarPinesMaestro.jsx
import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";

import useEscClose from "../../useEscClose";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import GenerarPines from "./GenerarPinesMaestros";
import FiltroPines from "./FiltroPinesMaestros";
import EditarPines from "./EditarPinesMaestros";
// ============================
const DEFAULT_PAGE_SIZE = 30;

// ============================
// COMPONENTE
// ============================
export default function ListarPinesMaestro() {
      // ============================
      //        LISTADO
      // ============================
      const [items, setItems] = useState([]);
      const [paginaActual, setPaginaActual] = useState(1);
      const [porPagina, setPorPagina] = useState(DEFAULT_PAGE_SIZE);
      const [totalBackend, setTotalBackend] = useState(0);
      const [cargando, setCargando] = useState(false);
      // ============================
      //        FILTROS
      // ============================
      const [filtros, setFiltros] = useState({});
      const [mostrarFiltros, setMostrarFiltros] = useState(false);
      useEscClose(() => setMostrarFiltros(false), mostrarFiltros);
      const limpiarSeleccion = () => {
        const empty = {};
        setFiltros(empty);
        setPaginaActual(1);
        fetchPines(0, porPagina, empty);
      };
    
      // ============================
      //     GENERAR PINES (MODAL)
      // ============================
      const [showGenerar, setShowGenerar] = useState(false);
      useEscClose(() => setShowGenerar(false), showGenerar);
      // ============================
      //        EDITAR PIN
      // ============================
      const [showEdit, setShowEdit] = useState(false);
      const [pinIdEdit, setPinIdEdit] = useState(null);
      useEscClose(() => setShowEdit(false), showEdit);

  // ============================
    //        FETCH REAL
    // ============================
    const fetchPines = async (page = paginaActual,size = porPagina,filtrosAplicados = filtros) => {
        setCargando(true);
        try {
            const data = await appFetchJson(
            apiRoutes.pines.listMaestros({
                page: page - 1, // backend 0-based
                size,

                // 🔥 filtros reales
                numero: filtrosAplicados.numero ?? null,
                numeroResponsable: filtrosAplicados.numeroResponsable ?? null,
                estadoId: filtrosAplicados.estadoId ?? null,
                eessId: filtrosAplicados.eessId ?? null,
            })
            );

            setItems(data.items ?? []);
            setTotalBackend(data.totalElements ?? 0);
        } catch (err) {
            console.error("Error cargando pines playeros", err);
            setItems([]);
            setTotalBackend(0);
        } finally {
            setCargando(false);
        }
    };


    useEffect(() => {
        fetchPines(0, porPagina, filtros);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  // ============================
  //        PAGINACIÓN
  // ============================
  const totalPaginas = Math.max(
    1,
    Math.ceil(totalBackend / porPagina)
  );

  const cambiarPagina = (num) => {
    const pagina = Math.min(Math.max(num, 1), totalPaginas);
    setPaginaActual(pagina);
    fetchPines(pagina, porPagina);
  };

  // ============================
  //        RENDER
  // ============================
  return (
    <div className="page">
      <ListHeader
        title="Lista de Pines de Maestros"
        onFilterClick={() => setMostrarFiltros(true)}
        filters={filtros}
        onClearFilters={limpiarSeleccion}
        showAdd
        addLabel="Generar PINES"
        onAddClick={() => setShowGenerar(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPaginaActual(1);
          fetchPines(0, size, filtros);
        }}
      />
      {/* =========================
          MODALES
          ========================= */}
      {showGenerar && (
      <GenerarPines
          onClose={() => setShowGenerar(false)}
          onSaved={() => {
          setShowGenerar(false);
          fetchPines(paginaActual - 1, porPagina, filtros);
          }}
      />
      )}

      {showEdit && (
          <EditarPines
          id={pinIdEdit}
          onClose={() => setShowEdit(false)}
          onSaved={() =>
              fetchPines(paginaActual - 1, porPagina, filtros)
          }
          />
      )}

      {/* =========================
        FILTROS
        ========================= */}
      {mostrarFiltros && (
      <FiltroPines
          initialFilters={filtros}
          onSubmit={(nuevosFiltros) => {
          setFiltros(nuevosFiltros);
          setPaginaActual(1);
          setMostrarFiltros(false);
          fetchPines(0, porPagina, nuevosFiltros);
          }}
          onClose={() => setMostrarFiltros(false)}
      />
      )}

      {/* TABLA */}
      <div className="overflow-x-auto mt-4">
        <table className="table-card table-sm">
          <thead className="table-head">
            <tr>
              <th className="cell text-right">Nro. Responsable</th>
              <th className="cell text-center">Nro. de PIN</th>
              <th className="cell text-left">Tipo</th>
              <th className="cell text-left">EE.SS.</th>
              <th className="cell text-left">Responsable</th>
              <th className="cell text-left">Estado</th>
              <th className="cell-center">Acción</th>
            </tr>
          </thead>

          <tbody>
            {cargando ? (
              <tr>
                <td colSpan={7} className="cell text-center">
                  Cargando…
                </td>
              </tr>
            ) : items.length === 0 ? (
              <tr>
                <td colSpan={7} className="cell text-center">
                  Sin resultados
                </td>
              </tr>
            ) : (
              items.map((row, i) => (
                <tr key={row.id} className={i % 2 === 0 ? "row-alt" : ""}>
                  <td className="cell text-right">
                    {row.numeroResponsable}
                  </td>
                  <td className="cell text-center">
                    {String(row.numero).padStart(4, "0")}
                  </td>
                  <td className="cell">
                    {row.tipo}
                  </td>
                  <td className="cell">
                    {row.eessNombre}
                  </td>
                  <td className="cell">
                    {row.descripcionResponsable || ""}
                  </td>
                  <td className="cell">
                    {row.estadoNombre}
                  </td>
                  <td className="cell-center">
                    <button
                      className="icon-btn"
                      title="Editar"
                      onClick={() => {
                        setPinIdEdit(row.id);
                        setShowEdit(true);
                      }}
                    >
                      <FaEdit />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ListFooter
        page={paginaActual}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={cambiarPagina}
      />
    </div>
  );
}
